import { render, staticRenderFns } from "./KeywordPlanner.vue?vue&type=template&id=4b3f0af3&"
import script from "./KeywordPlanner.vue?vue&type=script&lang=js&"
export * from "./KeywordPlanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev ii\\my work\\seo-team-flow\\vue templates\\Vuetify Soft UI Dashboard PRO\\seo-team-flow-ii\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b3f0af3')) {
      api.createRecord('4b3f0af3', component.options)
    } else {
      api.reload('4b3f0af3', component.options)
    }
    module.hot.accept("./KeywordPlanner.vue?vue&type=template&id=4b3f0af3&", function () {
      api.rerender('4b3f0af3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Research/KeywordPlanner.vue"
export default component.exports